// extracted by mini-css-extract-plugin
export default {"translated":"Translated_translated__k+s3C","left":"Translated_left__t8Ihs","post":"Translated_post__VUm0c","btn":"Translated_btn__Pog+z"};